module.exports = __webpack_public_path__ + "media/testimonials/customer-5-395c0981.png";